// extracted by mini-css-extract-plugin
module.exports = {"box":"HorizontalTabs_box__3O6Qa"};